module.exports = __webpack_public_path__ + "img/camera.a6004989.png";